import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import type {
  ComingSoonLinkouts,
  ProjectLinkouts,
} from 'src/shared/constants/FeatureFlag';
import { Designer } from 'src/shared/constants/FeatureFlag';
import type { User } from 'src/shared/graphql/generated';
import { useTreatmentWithConfig } from 'src/shared/hooks';

const flagIsOn =
  (user: Partial<User | undefined>) =>
  (treatment: string, configValue: string | number | undefined) =>
    Boolean(user?.isHomeowner) && treatment === 'on' && Boolean(configValue);

export const useAvailableProjectCards = () => {
  const { user } = useHomeownerAppContext();
  const { treatment: projectLinkoutsTreatment, config: projectLinkoutsConfig } =
    useTreatmentWithConfig<ProjectLinkouts>(Designer.PROJECT_LINKOUTS);

  const { treatment: comingSoonTreatment, config: comingSoonConfig } =
    useTreatmentWithConfig<ComingSoonLinkouts>(Designer.COMING_SOON);

  const heFlagIsOn = flagIsOn(user);

  const showComingSoon = heFlagIsOn(
    comingSoonTreatment,
    comingSoonConfig?.comingSoon?.title,
  );

  const showConnectPro = heFlagIsOn(
    comingSoonTreatment,
    comingSoonConfig?.connectPro?.title,
  );

  const showExploreServices = heFlagIsOn(
    projectLinkoutsTreatment,
    projectLinkoutsConfig?.exploreServices?.length,
  );

  return { showComingSoon, showConnectPro, showExploreServices };
};
